/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({
    "data": {
      "es": {
        "categories": {
          "cardinal": ["one", "other"],
          "ordinal": ["other"]
        },
        "fn": function fn(n, ord) {
          if (ord) return 'other';
          return n == 1 ? 'one' : 'other';
        }
      }
    },
    "aliases": {},
    "parentLocales": {
      "es-AR": "es-419",
      "es-BO": "es-419",
      "es-BR": "es-419",
      "es-BZ": "es-419",
      "es-CL": "es-419",
      "es-CO": "es-419",
      "es-CR": "es-419",
      "es-CU": "es-419",
      "es-DO": "es-419",
      "es-EC": "es-419",
      "es-GT": "es-419",
      "es-HN": "es-419",
      "es-MX": "es-419",
      "es-NI": "es-419",
      "es-PA": "es-419",
      "es-PE": "es-419",
      "es-PR": "es-419",
      "es-PY": "es-419",
      "es-SV": "es-419",
      "es-US": "es-419",
      "es-UY": "es-419",
      "es-VE": "es-419"
    },
    "availableLocales": ["es"]
  });
}